module.exports = __webpack_public_path__ + "static/media/reactLogo.550add2e.svg";